import React, { useEffect, useContext } from "react";
import { Container, Typography, Box, Link, Grid, Stack } from "@mui/material";
import { ButtonExternalLink } from "components/common";
import { GetContentTherapeuticAreasAllData } from "utils/api/getContent";
import appContext from "utils/context";
import useUserTracking from "utils/useTracking";
import theme from "utils/theme";

const RCPInfo = () => {
  useUserTracking({
    page: "rcp",
  });

  const {
    data: therapeuticAreasAllData,
    // isError,
    // isPending,
  } = GetContentTherapeuticAreasAllData();

  // console.log("therapeuticAreasAllData", Object.values(therapeuticAreasAllData));

  const rcps = therapeuticAreasAllData
    ? Object.values(therapeuticAreasAllData)
        .filter(
          (therapeuticArea) =>
            therapeuticArea?.indications?.find(
              (indication) =>
                indication?.repository &&
                indication?.repository.length &&
                indication?.repository?.find((rcp) => rcp.show_in_rcp) !==
                  undefined
            ) !== undefined
        )
        .map((therapeuticArea) => {
          // console.log(therapeuticArea.slug);
          const rcpsFound = [];
          therapeuticArea.indications.forEach((indication) => {
            // console.log(therapeuticArea.slug, ">", indication.slug);
            if (
              indication?.repository &&
              indication?.repository.length &&
              indication?.repository?.find((rcp) => rcp.show_in_rcp)
            ) {
              indication.repository
                .filter((rcp) => rcp.show_in_rcp)
                .forEach((rcp) => {
                  // console.log("rcp found", rcp);
                  rcpsFound.push({
                    therapeutic_area: therapeuticArea.slug,
                    therapeutic_area_indication: indication.slug,
                    ...rcp,
                  });
                });
            }
          });

          return rcpsFound;
        })
        .flat()
    : [];

  // console.log("rcps", rcps);

  const groupedRCPs = rcps.reduce((acc, rcp) => {
    const { therapeutic_area, therapeutic_area_indication } = rcp;

    if (!acc[therapeutic_area]) {
      acc[therapeutic_area] = {};
    }

    if (!acc[therapeutic_area][therapeutic_area_indication]) {
      acc[therapeutic_area][therapeutic_area_indication] = [];
    }

    acc[therapeutic_area][therapeutic_area_indication].push(rcp);

    return acc;
  }, {});

  // console.log("groupedRCPs", groupedRCPs);

  const { setIsWhiteContentPage } = useContext(appContext);
  useEffect(() => {
    setIsWhiteContentPage(true);

    return () => {
      setIsWhiteContentPage(false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    rcps &&
    therapeuticAreasAllData && (
      <Box
        sx={{
          background:
            "linear-gradient(180deg, transparent 379px, rgba(255,255,255,1) 379px)",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "start",
        }}
      >
        <Box
          sx={{
            height: { xs: 160, sm: 180 },
            position: "relative",
            // background: `url(/assets/images/products/banners/search.png) transparent no-repeat center`,
            // backgroundSize: "cover",
          }}
        >
          <video
            muted
            loop
            autoPlay
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center right",
            }}
          >
            <source
              src={`/assets/images/products/banners/rcp.mp4`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </Box>
        <Container maxWidth="xl">
          <Box paddingY={3}>
            <Stack direction="row" alignItems="center" gap={3}>
              <Typography variant="h1" sx={{ fontWeight: 700 }}>
                Informații de prescriere aprobate – RCP
              </Typography>
            </Stack>
          </Box>
        </Container>
        <Box
          sx={{
            background: "rgba(255,255,255,1)",
            paddingTop: 2,
          }}
        >
          <Container
            maxWidth="xl"
            sx={{
              position: "relative",
              paddingBottom: {
                xs: "20px",
                sm: "140px",
                md: "120px",
                lg: "100px",
              },
              height: "100%",
              minHeight: "100%",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              justifyContent: "center",
            }}
          >
            <Box paddingY={4}>
              {rcps.length === 0 ? (
                <Typography sx={{ color: theme.palette.primary.black }}>
                  Nicio informație de prescriere aprobată disponibilă.
                </Typography>
              ) : (
                Object.entries(groupedRCPs).map(
                  ([therapeutic_area, indications]) => (
                    <Box key={therapeutic_area} marginBottom={6}>
                      <Typography
                        variant="h2"
                        sx={{
                          color: "secondary.dark",
                          marginBottom: 3,
                          fontWeight: 700,
                        }}
                      >
                        {therapeuticAreasAllData[therapeutic_area].title}
                      </Typography>

                      {Object.entries(indications).map(
                        ([therapeutic_area_indication, rcpsList]) => (
                          <Box
                            key={therapeutic_area_indication}
                            marginBottom={3}
                          >
                            <Grid container spacing={4}>
                              {rcpsList.map((rcp, index) =>
                                rcp?.files.map((file, indexFile) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    key={`repository-${index}-${indexFile}`}
                                  >
                                    <ButtonExternalLink
                                      fullWidth
                                      component={Link}
                                      href={file.file_url}
                                      target="_blank"
                                      rel="noreferrer"
                                      variant="text"
                                      sx={{
                                        minHeight: 190,
                                        height: "100%",
                                        padding: theme.spacing(3, 3, 5, 3),
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: "1.875rem",
                                        background:
                                          "linear-gradient(268deg, #670040 -0.83%, #830051 21.85%, #250017 71.86%, #690041 97.37%)",
                                        "&:hover": {
                                          borderColor: "secondary.darker",
                                          "& .MuiButton-endIcon": {
                                            width: 28,
                                          },
                                        },
                                      }}
                                    >
                                      <Stack
                                        sx={{
                                          flexGrow: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Box sx={{ mb: 1 }}>
                                          <Typography
                                            sx={{
                                              fontSize: "1.125rem",
                                              textAlign: "center",
                                              wordBreak: "break-word",
                                              color: "white",
                                            }}
                                          >
                                            {file.type}
                                          </Typography>
                                        </Box>

                                        <Typography
                                          sx={{
                                            fontSize: "1.5rem",
                                            fontWeight: 700,
                                            textAlign: "center",
                                            wordBreak: "break-word",
                                            color: "white",
                                          }}
                                        >
                                          {file.title}
                                        </Typography>
                                      </Stack>
                                    </ButtonExternalLink>
                                  </Grid>
                                ))
                              )}
                            </Grid>
                          </Box>
                        )
                      )}
                    </Box>
                  )
                )
              )}
            </Box>
          </Container>
        </Box>
      </Box>
    )
  );
};

export default RCPInfo;
